import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'emotion-theming';

import Button from '../../../../shared/_TBComponents/Button';
import Link from '../../../../shared/_TBComponents/Link';
import Text from '../../../../shared/_TBComponents/Text';

const DuplicateError = ({ email }) => {
  const theme = useTheme();

  const handleTryAgain = () => {
    window.location.href = 'https://www.teambuildr.com/coach-signup';
  };

  if (!email) {
    return (
      <>
        <Text styledTextProps={{ fontSize: '34px', fontWeight: '700', textAlign: 'center' }}>Something went wrong...</Text>
        <Link
          allCaps
          className='return-link'
          color='lightText.1'
          href='/login'
        >
          Go to login
        </Link>
      </>
    );
  }

  return (
    <>
      <Text styledTextProps={{ fontSize: '34px', fontWeight: '700', textAlign: 'center' }}>Email already in use</Text>
      <Text styledTextProps={{ fontSize: '19px', fontWeight: '400', textAlign: 'center' }} styledWrapperProps={{ marginTop: '40px' }}>
        The email address
        {' '}
        <b>{email}</b>
        {' '}
        is already associated with an account. Please use a different email address.
      </Text>
      <Button
        bgColor={theme.colors.orange}
        fontSize='14px'
        fullWidth
        large
        name='Try again'
        noBorder
        onClick={handleTryAgain}
        rounded
        styledWrapperProps={{ marginTop: '40px' }}
        txtColor={theme.colors.white}
        upperCase
      />
      <Link
        allCaps
        className='return-link'
        color='lightText.1'
        href='/login'
      >
        Go to login
      </Link>
    </>
  );
};

DuplicateError.propTypes = {
  email: PropTypes.string.isRequired,
};

export default DuplicateError;
